<template>
  <v-card rounded="xl" flat>
    <v-card-text class="d-flex align-center justify-center">
      <div class="list-management-menu">
        <v-btn
          class="rounded-lg"
          outlined
          color="teal darken-3"
          @click="$emit('editOrder')"
          :disabled="teachersList.length === 0">
          <v-icon small left>
            fa-edit
          </v-icon >
          Ред.
        </v-btn>
        <v-btn
          class="rounded-lg"
          outlined
          color="teal darken-3"
          @click="resetEffConOrdersReview"
          :loading="loadingResetBtn"
          :disabled="teachersList.length === 0">
          Вернуть
          <v-icon small right>
            fa-reply
          </v-icon>
        </v-btn>
        <v-btn
          class="rounded-lg"
          outlined
          color="teal darken-3"
          @click="$emit('clearSelectedTeachers')"
          :disabled="teachersList.length === 0">
          Сбросить
          <v-icon small right>
            fa-check-square
          </v-icon>
        </v-btn>
      </div>
      <v-spacer/>
      <v-text-field
        label="Поиск по таблице"
        outlined
        v-model="search"
        dense
        hide-details
        style="max-width: 350px"
        class="rounded-lg"
        @input="$emit('search', search)"
      >
      </v-text-field>
      <v-btn
        outlined
        color="teal darken-3"
        class="rounded-lg mx-3"
        @click="$emit('filter')"
      >
        <v-icon left small>fa fa-filter</v-icon>
        Фильтр
      </v-btn>
      <v-btn
        outlined
        color="teal darken-3"
        class="rounded-lg"
        @click="reloadingListTeachers"
        :loading="loadingList"
      >
        <v-icon left small>fa fa-spinner</v-icon>Перезагрузка
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapActions, mapMutations} from "vuex";
import ApiServices from "../../../services/api.services";

export default {
  name: "TheHeaderTableUmuSection",

  data() {
    return {
      search: "",
      loadingList: false,
      loadingResetBtn: false,
    };
  },

  props: {
    arrayFilters: Array,
    teachersList: Array,
  },

  methods: {
    ...mapActions({
      getTeacherList: "effective_contract/getTeacherList",
    }),

    ...mapMutations({
      setTeachersList: "effective_contract/setTeachersList",
    }),

    async reloadingListTeachers() {
      this.loadingList = true;
      await this.getTeacherList();
      this.loadingList = false;
    },

    async resetEffConOrdersReview() {
      const ids = _.map(this.teachersList, (i) => i.teacher_eff_order.id);
      const response = await ApiServices.resetEffConOrdersReview(ids);
      this.loadingResetBtn = true;

      if (response?.statusText === "OK") {
        await this.setTeachersList(response.data.teachers_list);
      }
      this.loadingResetBtn = false;
    },

  },
}
</script>

<style scoped>
  .list-management-menu:nth-child(2n) {
    margin: 0 8px;
  }
</style>